import React from 'react';
import BottomButtons from '@/ui/modal/bottom-buttons/BottomButtons';
import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import s from './fee-modal.module.css';

const FeeModal = ({
	feeList,
	label = 'Άλλη προμήθεια',
	changeCustomFee,
	selectedFeeIdx,
	changeSelectedFeeIdx,
	customFee,
	onSave,
	saveText,
}) => {
	return (
		<div className={'flex min-h-60 min-w-84 flex-col'}>
			<div className={''}>
				{feeList?.length > 0 && (
					<div>
						<div className={s.fees_container}>
							{feeList.map((fee, idx) => (
								<div
									key={fee}
									className={`${s.fee} ${selectedFeeIdx === idx && s.feeSelected}`}
									onClick={() => changeSelectedFeeIdx(idx)}
								>
									{fee}
								</div>
							))}
						</div>
					</div>
				)}
				<div
					className='mt-4 flex flex-row items-center'
					// style={customFee && { borderWidth: 2, borderColor: 'red' }}
				>
					<FloatingTextinput
						value={customFee}
						label={label}
						onChange={e => {
							// console.log('iiiii', customFee, e);
							// changeSelectedFeeIdx(null)
							changeCustomFee(e);
						}}
						white
					/>
				</div>
				<BottomButtons onSave={onSave} saveDisabled={false} text={saveText} />
			</div>
		</div>
	);
};

export default FeeModal;
